import type { MoodEntry } from '../../types/mood';

export const ethereal: MoodEntry = {
  id: 'ethereal',
  name: 'Ethereal',
  synonyms: ['ephemeral', 'ethereal', 'delicate', 'transient', 'passing', 'brief', 'light', 'airy', 'otherworldly', 'celestial', 'subtle'],
  related: ['fleeting', 'momentary', 'graceful', 'dreamlike'],
  antonyms: ['heavy', 'grounded', 'lasting', 'enduring'],
  behaviours: ['moving softly', 'noticing details', 'speaking gently', 'letting moments pass'],
  actions: ['pause and observe', 'take a quiet walk', 'breathe slowly', 'notice what feels light'],
  phrases: ['Let the moment stay tender.', 'Some things are beautiful because they pass.', 'Lightness can be its own kind of strength.', 'Hold it lightly.'],
  quotes: [
    '“To fly, we have to have resistance.” — Maya Lin',
    '“The soul that sees beauty may sometimes walk alone.” — Johann Wolfgang von Goethe'
  ],
  palette: ['#EEF6FF', '#DCEBFA', '#C7DDF2', '#AFCFE8'],
  season: 'Winter'
};